<template>
	<div id="pim_main">
		<PuSkeleton class="PuSkeleton" v-if="this.$route.name != 'Checkout'"/>
		<Landing v-if="!this.$root.isLocation" />
		<div v-else>
		    
			<Header v-if="this.$route.name != 'Checkout'" />
			<div class="container-fluid  message-container" >
				<!-- <div
					class="page_loaderHome"
					id="r_page_loader"
					v-show="this.$root.page_loader == true"
				>
				<loading-icon class="loading-icon" name="ball-clip-rotate-multiple" color="#ba2126" scale="1"></loading-icon>
				</div> -->
			</div>
			<div id="st-container-hide">
				<transition name="fade" mode="out-in" @after-leave="afterLeave">
					<router-view :key="$route.path + $root.searchCount"></router-view>
				</transition>
			</div>
			<Footer v-if="this.$route.name != 'Checkout'" />
		</div>
	</div>
</template>
<script>
	
	import axios from "axios";
	import Header from "./components/Header/Header.vue";
	import Footer from "./components/Footer/Footer";
	import Landing from "./components/Home/Landing";
	import Loader from "./components/Loader";
	export default {
		metaInfo() {
			return {
				link: [
					{ rel: "icon", href: this.favicon, },
				],
				title: "WNDW | From your favourite store to your door in 3 hours or less",
      			meta:[
        			{name: 'description', content: 'The one-stop shop for all your shopping needs, delivered in 3 hours or less. Buy Groceries, Electronics, Fashion, Beauty, Home, Pet Care, Gifting, and Medicines.'}
      			], 
			};
		},
		name: "pimweb",
		components: {
			Header,
			Footer,
			Landing,
			Loader,
		},
		data: function () {
			return {
				cart_loader_skeleton : true,
				menu: [],
				favicon: "",
				isParentRendered: false,
				isLocation: false,
				lat: "",
				long: "",
			};
		},
		mounted () {
		
			document.addEventListener("mouseup", e => {
				this.$toast.clear()
			})
		
		},

		created: function () {
			//   if(this.$route.name != 'Checkout'){
			// this.isParentRendered = true
			//   }
			//   else{
			//     this.isParentRendered = false
			//   }
			// this.$root.page_loader = true;

			this.get_menu();
		// this.getAddress()
			this.get_account();
			this.get_page();
			if (this.$root.location.lat) {
				this.$root.isLocation = true;
			}
			if (
				this.$route.name != "cart" &&
				this.$route.name != "Checkout" &&
				this.$route.name != "Thankyou"
			) {
				this.get_cart();
			}

			if (this.$root.store === 1) {
				this.favicon = "/img/fav.png";
			} else {
				this.favicon = "/img/fav2.ico";
			}
			window.addEventListener("resize", this.handleResize);
			this.handleResize();
		},
		destroyed() {
			window.removeEventListener("resize", this.handleResize);
		},
		methods: {
			handleResize() {
				this.$root.window.width = window.innerWidth;
				this.$root.window.height = window.innerHeight;
			},
			getLocation() {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition((position) => {
						//  console.log("called form location");
						this.$root.location.lat = position.coords.latitude;
						this.$root.location.long = position.coords.longitude;
						//  console.log(position);
					}),
						function (error) {
							console.log(error.message);
						},
						{
							enableHighAccuracy: true,
							// , timeout: 5000
						};
				}
			},
			afterLeave() {
				this.$root.$emit("triggerScroll");
			},

			get_account: function () {
				if (this.$root.customer_id != null && this.$root.customer_id != "") {
					this.$root.error_message = "";
					this.$root.success_message = "";
					var form = new FormData();
					form.append("customer_id", this.$root.customer_id);
					form.append("customer_session", this.$root.customer_session);
					form.append("store", this.$root.store);
					axios.post(this.$root.cart_api + "/customer/account-details", form)
						.then((response) => {
							if (response.data.success === true) {
								this.$root.wishListProducts = response.data.data.wishlistCount;
								// console.log("called add");
								this.$root.address = [...response.data.data.address];
								this.$root.storeCredit = response.data.data.storeCredit;
								this.isParentRendered = true;
								this.$root.outTandingBalance =  response.data.data.outstandingBalance;
								// console.log(response.data.data.full_name);
													this.$root.customerDetails.name = response.data.data.full_name;
														this.$root.customerDetails.number = response.data.data.phone;
								

								// console.log(this.$root.address);
							} else {
								
								this.isParentRendered = true;
								if (
									response.data.customer_session_status == false ||
									response.data.cart_session_status == false
								) {
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_customer",
										"",
										"1y"
									);
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cs",
										"",
										"1y"
									);
									this.$root.customer_id = "";
									this.$root.customer_session = "";
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cart",
										"",
										"1y"
									);
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_carts",
										"",
										"1y"
									);
									this.$root.pcart = "";
									this.$root.cart_session = "";
									this.$root.cart_product = [];
								}
							}
						});
				}
			},
			// getAddress(){
			// 	console.log("called");
			// 	var form = new FormData();
			// 		form.append("customer_id", this.$root.customer_id);
			// 		form.append("customer_session", this.$root.customer_session);
				
			// 		axios
			// 			.post(this.$root.cart_api + "/customer/get-last-addresses", form)
			// 			.then((response) => {
			// 				console.log(response);
			// 				if (response.data.success === true) {
			// 					this.$root.locationAddresses = response.data.data
			// 					// this.$root.locationAddresses = response.data
			// 				}
			// 			}).catch(err=>{

			// 			})

			// },
			get_page: function () {
				axios
					.get(
						this.$root.api_url +
							`/pim/pimresponse.php?service=cms_page&store=${this.$root.store}`
					)
					.then((response) => {
						if (response.data.response.success == 1) {
							this.$root.pages = response.data.result;
						}
					});
			},
			get_menu: function () {
				axios
					.get(
						this.$root.api_url +
							`/pim/pimresponse.php?service=menu&store=${this.$root.store}`
					)
					.then((response) => {
						this.$root.menu = response.data.result;
						this.$root.page_loader = false;
					})
					.catch((error) => {
						if (error.message === "Network Error") {
							this.$root.error_message =
								"Oops there seems to be some Network issue, please try again.";
						}
						window.scrollTo(0, 0);
					});
			},
			groupByKey(array, key) {
				return array.reduce((hash, obj) => {
					if (obj[key] === undefined) return hash;
					return Object.assign(hash, {
						[obj[key]]: (hash[obj[key]] || []).concat(obj),
					});
				}, {});
			},
			get_cart: function () {
				if (this.$root.pcart != null && this.$root.pcart != "") {
					var form = new FormData();
					form.append("pcart", this.$root.pcart);
					form.append("cart_session", this.$root.cart_session);
					axios
						.post(this.$root.cart_api + "/cart/get-cart", form)
						.then((response) => {
							if (response.data.success === true) {
								this.$root.shipping_charge =  response.data.shippingCharge
								this.$root.cart_total = response.data.grandTotal
								this.$root.cart_subtotal = response.data.subTotal
								this.$root.cart_netAmount = response.data.netAmount
								this.$root.discount_amount = response.data.discountAmount

								if (this.$root.pcart === null) {
									this.$root.pcart = response.data.pcart;
									
								}
								if (response.data.data.length > 0) {
									let ProductsArray = [];
									// Sorting Products array according to SKU

									if (response.data.data[0].cookieDelete === 1) {
										this.$cookies.set(window.location.hostname.substring(10, 4) + "_cart","");
										this.$root.pcart = "";
									}
									response.data.data.forEach((cart) => {
										ProductsArray = [...ProductsArray,...cart.products]
									});

									this.$root.cart_product = ProductsArray;
									

								} else {
									this.$root.cart_product = []
									this.$root.shipping_charge =  response.data.shippingCharge
									this.$root.cart_total = response.data.grandTotal
									this.$root.cart_subtotal = response.data.subTotal
									this.$root.cart_netAmount = response.data.netAmount
									this.$root.discount_amount = response.data.discountAmount

									//  this.$store.dispatch('getCart', response.data.data.products)
								}

								if (response.data.data.cookieDelete === 1) {
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cart",
										""
									);
									this.$root.pcart = "";
								}
								// if(this.$root.address.length != 0){
								//   for(let i = 0; i < this.$root.address.length; i++){
								//     if(i == 0)
								//     {
								//       this.$root.address_id = this.$root.address[i].id*1;
								//       this.$root.select_address_no = i;
								//     }
								//   }
								// }
								this.$root.page_loader = false
							} else {
								if (
									response.data.customer_session_status == false ||
									response.data.cart_session_status == false
								) {
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_customer",
										"",
										"1y"
									);
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cs",
										"",
										"1y"
									);
									this.$root.customer_id = "";
									this.$root.customer_session = "";
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_cart",
										"",
										"1y"
									);
									this.$cookies.set(
										window.location.hostname.substring(10, 4) + "_carts",
										"",
										"1y"
									);
									this.$root.pcart = "";
									this.$root.cart_session = "";
									this.$root.cart_product = [];
								}
							}
							this.cart_loader_skeleton = false;
						})
						.catch((error) => {
							if (error.message === "Network Error") {
								this.$root.error_message =
									"Oops there seems to be some Network issue, please try again.";
							}
							window.scrollTo(0, 0);
						});
				}
			},
		},
	};
</script>
